import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Settings, MapPin, Home, Layers } from "lucide-react";

type EmptyStateType = "location" | "greenhouse" | "block";

interface EmptySelectStateProps {
  type: EmptyStateType;
  message: string;
  hint: string;
  actionLabel: string;
  settingsPath?: string;
}

const iconMap = {
  location: MapPin,
  greenhouse: Home,
  block: Layers,
};

export function EmptySelectState({ 
  type, 
  message, 
  hint, 
  actionLabel, 
  settingsPath = "/settings/structure" 
}: EmptySelectStateProps) {
  const navigate = useNavigate();
  const Icon = iconMap[type];

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(settingsPath);
  };

  return (
    <div className="flex flex-col items-center justify-center py-4 px-3 text-center">
      <div className="rounded-full bg-muted p-2 mb-2">
        <Icon className="w-5 h-5 text-muted-foreground" />
      </div>
      <p className="text-sm font-medium text-foreground">{message}</p>
      <p className="text-xs text-muted-foreground mt-1">{hint}</p>
      <Button 
        variant="link" 
        size="sm" 
        onClick={handleClick}
        className="mt-2 text-primary h-auto p-0"
      >
        <Settings className="w-3 h-3 mr-1" />
        {actionLabel}
      </Button>
    </div>
  );
}
